<template>
    <button class="sort-button" @click="doSort($event)" :class="active ? 'sort-active' : ''" :title="tooltip">
        <font-awesome-icon fixed-width :icon="arrow" /></button>
</template>

<script>

export default {
    name: 'SortButton',
    props: {
        columnId: String,
        sort: String,
    },
    data() {
        return {
            active: false,
            direction: null,
        }
    },
    methods: {
        doSort(event) {
            const additive = event.shiftKey;
            // first click is asc
            // second click is desc
            // third click is not sorted
            if (this.direction === null) {
                this.direction = 'asc';
            }
            else if (this.direction === 'asc') {
                this.direction = 'desc';
            }
            else if (this.direction === 'desc') {
                this.direction = null;
            }
            this.$emit('sortChanged', this.columnId, this.direction, additive);
        },
    },
    computed: {
        arrow() {
            if (this.direction == null) return 'sort';
            if (this.direction == 'asc') return 'sort-up';
            if (this.direction == 'desc') return 'sort-down';
        },
        tooltip() {
            if (this.direction == null) return 'Sort ascending';
            if (this.direction == 'asc') return 'Sort descending';
            if (this.direction == 'desc') return 'Clear sort';
        }
    },
    watch: {
        sort: {
            handler(value) {
                if (value === undefined) {
                    this.direction = null;
                    this.active = false;
                }
                else {
                    this.direction = value;
                    this.active = true;
                }
            },
            immediate: true,
        },
    }
}
</script>
<style scoped>
.sort-button {
    border: none !important;
    background: none;
    color: rgb(118, 118, 118) !important;
}
.sort-active {
    color: black !important;
}
</style>
